import { Datagrid, DateField, EditButton, List, TextField } from "react-admin";




export function PaintingList(props) {

    return (
        <List {...props} >
            <Datagrid rowClick="show"  >
                <TextField source="id" />
                <TextField source="title" />
                <EditButton />

            </Datagrid>
        </List>
    )
}